/* KLIK support form embed (snippets/klik-support-form.liquid): auto-height, ready/slow states, step scroll, theme tokens.
   Messages come only from https://orders.klikdecor.com and only from this iframe. Never submits anything.
   The frame is shown only after the form has reported its height AND its fonts are in use ({type:'fonts'}, sent by the
   form's /support-theme.js, which caps its own wait at 3 s; 3.5 s after the first height if that message never comes),
   so it appears once, in its final fonts and at its final height. An unanswered or error document is never shown: without a height message the
   skeleton stays, and 2.5 s after the frame's load event the "taking longer" note offers the separate page. */
(() => {
  const ORIGIN = 'https://orders.klikdecor.com';
  const frame = document.querySelector('.klik-support-frame');
  if (!frame) return;
  const box = frame.closest('.klik-support-embed') || frame.parentNode;
  const toastEl = box.querySelector('.ksp-toast');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const TOKENS = ['canvas', 'paper', 'linen', 'sand', 'stone', 'clay', 'ink', 'ink-2', 'muted', 'deep', 'cognac', 'caramel', 'bronze', 'gold', 'rule', 'rule-2', 'sh-1', 'sh-btn', 'sh-float', 'error-bg', 'error', 'ok-bg', 'ok'];
  let alive = false, fonts = false, shown = false, want = 0, raf = 0, sent = 0, slowTimer = 0, toastTimer = 0, fallback = 0;

  const reveal = () => { if (shown) return; shown = true; clearTimeout(fallback); box.classList.add('is-ready'); };
  // show one frame after the latest height is in place, so nothing moves under the fade
  const maybeReveal = () => { if (alive && fonts && !shown) requestAnimationFrame(() => requestAnimationFrame(reveal)); };
  const slow = () => { if (!alive) box.classList.add('is-slow'); };
  const applyHeight = () => {
    raf = 0;
    if (want && Math.abs(frame.getBoundingClientRect().height - want) > 2) frame.style.height = want + 'px';
  };
  const setHeight = (value) => {
    const h = Math.ceil(Number(value));
    if (!Number.isFinite(h) || h < 300 || h > 12000) return false;
    want = h;
    if (!raf) raf = requestAnimationFrame(applyHeight);
    return true;
  };
  // Hand the page's live design tokens to the form (on its first height message and again on load).
  const sendTokens = () => {
    if (sent > 1 || !frame.contentWindow) return;
    sent++;
    const cs = getComputedStyle(document.documentElement), tokens = {};
    for (const k of TOKENS) { const v = cs.getPropertyValue('--v3-' + k).trim(); if (v) tokens['--v3-' + k] = v; }
    if (Object.keys(tokens).length) frame.contentWindow.postMessage({ source: 'klik-theme', type: 'tokens', tokens }, ORIGIN);
  };
  const toast = (text) => {
    if (!toastEl) return;
    toastEl.textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.classList.remove('is-on'); toastEl.textContent = ''; }, 6500);
  };
  const header = () => (window.innerWidth < 750 ? 90 : 110);
  const handle = (event) => {
    if (event.origin !== ORIGIN || event.source !== frame.contentWindow) return;
    const d = event.data;
    if (!d || d.source !== 'klik-support') return;
    if (d.type === 'height' || d.type === 'fonts') {
      if (d.type === 'fonts') fonts = true;
      if (setHeight(d.height) && !alive) {
        alive = true;
        clearTimeout(slowTimer);
        box.classList.remove('is-slow');
        sendTokens();
        fallback = setTimeout(() => { fonts = true; maybeReveal(); }, 3500);
      }
      maybeReveal();
    } else if (d.type === 'step') {
      // a new step: bring the form card (its offset in the frame comes with the message) back under the header,
      // only when it is out of view
      const offset = Math.max(0, Math.min(Number(d.top) || 0, 2000));
      const top = frame.getBoundingClientRect().top + offset;
      if (top < header() - 4 || top > window.innerHeight * 0.6) {
        window.scrollTo({ top: Math.max(0, window.scrollY + top - header()), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    } else if (d.type === 'notice' && typeof d.text === 'string') {
      toast(d.text.slice(0, 200));
    }
  };

  const queued = window.__kspQ || [];
  window.__kspQ = null;
  window.addEventListener('message', handle);
  queued.forEach(handle);

  // loaded but silent (blocked, offline page, an error page): keep the skeleton, then offer the separate page
  const onLoad = () => { sendTokens(); setTimeout(() => { if (!alive) slow(); }, 2500); };
  if (frame.hasAttribute('data-loaded')) onLoad();
  else frame.addEventListener('load', onLoad, { once: true });

  // "Taking longer than usual": counted from when the lazy frame actually starts loading (near the viewport)
  const startSlowTimer = () => { if (!alive && !slowTimer) slowTimer = setTimeout(slow, 12000); };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); startSlowTimer(); }
    }, { rootMargin: '600px 0px' });
    io.observe(frame);
  } else startSlowTimer();
})();
